import * as React from "react";
const SvgGridTypeDoubleDouble20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M9 1v18H7V1h2Zm4 0v18h-2V1h2Zm6 12h-5v-2h5v2ZM6 7v2H1V7h5Zm13 2h-5V7h5v2ZM6 11v2H1v-2h5Z",
      clipRule: "evenodd"
    })
  );
export default SvgGridTypeDoubleDouble20Px;
